<template>
  <el-config-provider :locale="appStore.locale" :size="size" id="app">
    <router-view />
  </el-config-provider>
</template>

<script setup lang="ts">
import { computed, onMounted, nextTick } from 'vue'
import useSettingsStore from '@/store/modules/settings'
import { handleThemeStyle } from '@/utils/theme'
import useAppStore from '@/store/modules/app'
import { useHistoryTab } from '@/store/modules/historyTab'

const appStore = useAppStore()
const size = computed(() => appStore.size as any)

// 监听路由变化
useHistoryTab().listenRouter()

onMounted(() => {
  nextTick(() => {
    // 初始化主题样式
    handleThemeStyle(useSettingsStore().theme)
  })
})
</script>
<style lang="less">
html {
  font-size: 0.4375rem;
}
#app {
  font-family: 'Microsoft Yahei';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  // overflow-x: hidden;
  background: transparent !important;
}
input {
  background-color: transparent;
  border: none;
  -webkit-appearance: none;
  border-radius: 0;
  outline: none;
}
input:-webkit-autofill,
input textarea:-webkit-autofill,
input select:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 31.25rem transparent inset !important;
  background-color: transparent;
  background-image: none;
  -webkit-transition: background-color 50000s ease-in-out 0s;
  transition: background-color 50000s ease-in-out 0s;
}
textarea {
  border: none;
}
.bg-top {
  width: 100%;
  height: 17.0625rem;
}
.icon-50 {
  position: absolute;
  max-width: 22.59375rem;
  max-height: 22.84375rem;
  left: 5.28125rem;
  top: 6.71875rem;
}
@media screen and (max-width: 1200px) {
  .bg-top {
    height: 11.34375rem !important;
  }
}
/* 阿里字体图标设置 */
.icon,
.iconfont {
  font-family: 'iconfont' !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}
</style>